// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"blog-post-module--blog-post--2nvQZ","blogPostNav":"blog-post-module--blog-post-nav--3vzxe"};